export default __webpack_public_path__ + "static/media/picto-topografico_classico.4bba71b3.svg";